import { useEffect, useState } from 'react'

type PopupControls = {
  isOpened: boolean
  openPopup: () => void
  closePopup: () => void
  togglePopup: () => void
}

export type usePopupControlsProps = {
  initialValue?: boolean
  isHideScroll?: boolean
}

const html = document.getElementsByTagName('html')[0]
const body = document.getElementsByTagName('body')[0]

const usePopupControls = (props?: usePopupControlsProps): PopupControls => {
  const [isOpened, setIsOpened] = useState(props?.initialValue || false)

  const hideScroll = () => {
    html.style.overflow = 'hidden'
    body.classList.add('hide')
  }

  const revealScroll = () => {
    html.style.overflow = 'initial'
    body.classList.remove('hide')
  }

  useEffect(() => {
    if (props?.isHideScroll) {
      if (isOpened) {
        hideScroll()
      } else {
        revealScroll()
      }
    }
  }, [isOpened, props?.isHideScroll])

  const openPopup = () => {
    setIsOpened(true)
  }
  const closePopup = () => setIsOpened(false)
  const togglePopup = () => setIsOpened(prev => !prev)

  return { isOpened, openPopup, closePopup, togglePopup }
}

export { usePopupControls }
export type { PopupControls }
